import React from 'react'

import { Box, Container, Grid } from '@material-ui/core'

import Spinner from '../../../UI/Spinner/Spinner'

import FeedbackBox from './FeedbackBox/FeedbackBox'
import UserList from './UserList/UserList'

const FeedbackPanel = ({
  empList,
  structureList,
  selectedEmpId,
  userClicked,
  itemExpanded,
  chatHistory,
  onFeedbackSubmit,
  onFeedbackFileClick,
  onFeedbackScroll,
  loadingStates,
  isAdmin
}) => {
  const loading = loadingStates.includes('feedbackStructure')

  let content = <Spinner minHeight={'calc(35vh + 150px)'} />
  if (!loading) {
    content = (
      <FeedbackBox
        availableStructures={structureList}
        onItemExpanded={itemExpanded}
        onFeedbackSubmit={onFeedbackSubmit}
        onFeedbackFileClick={onFeedbackFileClick}
        chatHistory={chatHistory}
        onFeedbackScroll={onFeedbackScroll}
        chatInputLoading={loadingStates.includes('postFeedback')}
        chatLoading={loadingStates.includes('feedbackHistory')}
        isAdmin={isAdmin}
      />
    )
  }
  return (
    <Container component={Box} p={1}>
      <Grid container justify={'space-around'} alignItems={'flex-start'} spacing={2}>
        <Grid item xs={5} lg={3}>
          <UserList onUserClicked={userClicked} selectedEmpId={selectedEmpId} users={empList} />
        </Grid>
        <Grid item xs={7} lg={9}>
          {content}
        </Grid>
      </Grid>
    </Container>
  )
}

export default FeedbackPanel
